export type OS = "Windows" | "Mac";

export const getOS = (): OS => {
  if (navigator.userAgent.indexOf("Mac") !== -1) {
    return "Mac";
  }

  return "Windows";
};
